export default "__VITE_ASSET__BIwiFmfn__"